import { render, staticRenderFns } from "./AssessmentActionsPopUp.vue?vue&type=template&id=f37acaea&scoped=true"
import script from "./AssessmentActionsPopUp.vue?vue&type=script&lang=js"
export * from "./AssessmentActionsPopUp.vue?vue&type=script&lang=js"
import style0 from "./AssessmentActionsPopUp.vue?vue&type=style&index=0&id=f37acaea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f37acaea",
  null
  
)

export default component.exports